/**
 * Uses uspStore for artist USP (api/v2/artist/usp/).
 * Returns display text: API usp if present, otherwise a placeholder explaining what USP is.
 */

import { useEffect } from "react";
import { useUspStore } from "@/stores/uspStore";

export const USP_PLACEHOLDER =
  "Your USP (Unique Selling Proposition) tells clients why they should choose you. What makes you different from other artists? Add it in Profile → USP to stand out and win more bookings.";

export function useArtistUsp() {
  const data = useUspStore((s) => s.data);
  const ensureFetched = useUspStore((s) => s.ensureFetched);
  const isLoading = useUspStore((s) => s.isLoading);
  const fetchUsp = useUspStore((s) => s.fetchUsp);

  useEffect(() => {
    ensureFetched();
  }, [ensureFetched]);

  const raw = data?.usp;
  const hasUsp = typeof raw === "string" && raw.trim().length > 0;
  const uspText = hasUsp ? raw.trim() : USP_PLACEHOLDER;

  return {
    uspText,
    hasUsp,
    isLoading,
    isError: false,
    refetch: fetchUsp,
  };
}
